import React from 'react';

function PopularSearch() {
    const searches = [
        "One Person Company", "Nidhi Company", "Company Registration", "Tax Notice", 
        "Indian Subsidiary", "HSN Code", "Section 8 Company", "Trademark Search", 
        "USA Company Registration", "FSSAI Registration", "Import Export Code", 
        "ESI Registration", "Proprietorship", "GST Return Filing", "Patta Chitta", 
        "PF Registration", "Payroll", "Business Tax Return Filing", "PF Return Filing", 
        "Eway Bill", "GST Registration", "TDS Filing", "Udyam Registration", 
        "Trademark Registration", "Startup India Registration", "Professional Tax", 
        "Personal Tax Filing", "Check Company or LLP name Availability"
    ];

    return (
        <section className="popular-searches-section">
            <div className="container px-4">
                <div className="ps-header">
                    <div className="ps-icon-wrapper">
                        <i className="bi bi-search ps-search-icon"></i>
                    </div>
                    <div>
                        <h3 className="ps-title">Popular Searches</h3>
                        <p className="ps-subtitle">What others are looking for</p>
                    </div>
                </div>
                
                <div className="ps-tags-container">
                    {searches.map((search, index) => (
                        <a href="#!" key={index} className="ps-tag-pill">
                            {search}
                        </a>
                    ))}
                </div>
            </div>

            <style dangerouslySetInnerHTML={{
                __html: `
                .popular-searches-section {
                    padding: 60px 0;
                    background: #ffffff;
                    border-top: 1px solid #f1f5f9;
                    font-family: 'Inter', sans-serif;
                }

                .ps-header {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    margin-bottom: 30px;
                }

                .ps-icon-wrapper {
                    width: 45px;
                    height: 45px;
                    background: #f0fdf4;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #22c55e;
                    font-size: 18px;
                    box-shadow: 0 4px 15px rgba(34, 197, 94, 0.15);
                }

                .ps-title {
                    font-size: 24px;
                    font-weight: 800;
                    color: #0f172a;
                    margin: 0 0 4px 0;
                }

                .ps-subtitle {
                    margin: 0;
                    color: #64748b;
                    font-size: 14px;
                    font-weight: 500;
                }

                .ps-tags-container {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 12px;
                }

                .ps-tag-pill {
                    background: #f8fafc;
                    border: 1px solid #e2e8f0;
                    color: #475569;
                    padding: 10px 20px;
                    border-radius: 30px;
                    font-size: 13.5px;
                    font-weight: 600;
                    text-decoration: none;
                    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
                    box-shadow: 0 2px 10px rgba(0,0,0,0.01);
                }

                .ps-tag-pill:hover {
                    background: #115886;
                    border-color: #115886;
                    color: #ffffff;
                    transform: translateY(-3px);
                    box-shadow: 0 8px 20px rgba(17, 88, 134, 0.2);
                }

                @media (max-width: 768px) {
                    .popular-searches-section {
                        padding: 40px 0;
                    }
                    .ps-title {
                        font-size: 22px;
                    }
                    .ps-tag-pill {
                        padding: 8px 16px;
                        font-size: 12.5px;
                    }
                }
                `
            }} />
        </section>
    );
}

export default PopularSearch;